// Step 2: Attachments — delegates to the shared AttachmentsFormSection.
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AttachmentsFormSection } from '@/components/common/AttachmentsFormSection';
import { getStringError } from '../../utils/formErrorHelpers';
import type { Step2DetailsProps } from './Step2Details.types';

export const Step2Details = ({
  form,
  existingAttachments = [],
  onDeleteExistingAttachment,
  isLoading = false,
}: Step2DetailsProps) => {
  const { t } = useTranslation();

  const handleFilesChange = useCallback(
    (files: File[]) => {
      form.setFieldValue('attachments', files);
    },
    [form]
  );

  return (
    <AttachmentsFormSection
      files={form.values.attachments}
      onFilesChange={handleFilesChange}
      existingAttachments={existingAttachments}
      onDeleteExistingAttachment={onDeleteExistingAttachment}
      isLoading={isLoading}
      title={t('wizard.step2.heading')}
      description={t('wizard.step2.description')}
      existingFilesLabel={t('wizard.step2.existingFiles', {
        count: existingAttachments.length,
      })}
      error={getStringError(form.errors.attachments)}
    />
  );
};
